import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MenuItems from './MenuItems';
import Items from './Items.json';
import { history } from '../../helpers/history';
import MenuHeader from './MenuHeader';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import { useTheme, makeStyles, Divider, Typography } from '@material-ui/core';
import { sendMobile } from '../../functions/mobile';

const drawerWidth = 270;
const drawerWidthMobile = 200;

const useStyles = makeStyles((theme) => ({
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidthMobile,
      flexShrink: 0,
      backgroundColor : '#434041'
    },
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      flexShrink: 0,
      backgroundColor : '#434041'
    },
    [theme.breakpoints.up('lg')]: {
        width: drawerWidth,
        flexShrink: 0,
        backgroundColor : '#434041'
      },
    [theme.breakpoints.up('xl')]: {
      width: drawerWidth,
      flexShrink: 0,
      backgroundColor : '#434041'
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    [theme.breakpoints.up('xs')]: {
      width: drawerWidthMobile,
      backgroundColor: "#009aa8"
    },
    [theme.breakpoints.up('sm')]: {
      width: drawerWidthMobile,
      backgroundColor: "#009aa8"
    },
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      backgroundColor: "#009aa8"
    },
    [theme.breakpoints.up('lg')]: {
      width: drawerWidth,
      backgroundColor: "#009aa8"
    },
    [theme.breakpoints.up('xl')]: {
      width: drawerWidth,
      backgroundColor: "#009aa8"
    },
  },
  toolbarLogo: {

    paddingTop : "4%"

},
}));

const MenuDrawer = props => {
    const { open, closeDrawer, userState, window, primary, userQuestions } = props
    const classes = useStyles();
    const theme = useTheme();
    const [ menuselectedsimple, setMenuselectedsimple ] = useState("Estado de cuenta")
    const [ menuselectedcollapse, setMenuselectedcollapse ] = useState("");

    const sendData = (data, text) => {
      //console.log(data, text)
        setMenuselectedcollapse("")
        setMenuselectedsimple(text)
        open && closeDrawer()
        //console.log(userQuestions)
        if (userQuestions === 0) {
          history.push('/questions' )
        } else {
          if (userState === 0) {
            history.push('/password-change' )
          } else {
            history.push(data)
            const send = {
              type: 'paths',
              data
            }
            sendMobile(JSON.stringify(send))
          }
        }

    }

    const menuCollapseSelected = (text) => {
      //console.log(text);
      setMenuselectedsimple(text)
    }

    const submenuCollapseSelected = (data, text, textfather) => {
      setMenuselectedcollapse(text)
      setMenuselectedsimple(textfather)
      open && closeDrawer()
      if (userQuestions === 0) {
        history.push('/questions' )
      } else {
        if (userState === 0) {
          history.push('/password-change' )
        } else {
          history.push(data)
        }
      }
    }

    const container = window !== undefined ? () => window().document.body : undefined;
    return (
        <nav className={classes.drawer} aria-label="mailbox folders">
            <Hidden smUp implementation="css">
            <Drawer
                container={container}
                variant="temporary"
                anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                open={open}
                onClose={closeDrawer}
                classes={{
                paper: classes.drawerPaper,
                }}
                ModalProps={{
                keepMounted: true, // Better open performance on mobile.
                }}
            >
                <MenuHeader />
                <MenuItems items = { Items } sendData = { sendData } menuselectedsimple = { menuselectedsimple } submenuCollapseSelected = { submenuCollapseSelected } menuselectedcollapse = { menuselectedcollapse } menuCollapseSelected = { menuCollapseSelected }/>
            </Drawer>
            </Hidden>
            <Hidden xsDown implementation="css">
            <Drawer
                classes={{
                paper: classes.drawerPaper,
                }}
                variant="permanent"
                open
            >
                <Typography component="div"  className={classes.toolbar} style={{backgroundColor: primary }} align = "center">
                  <img src={process.env.PUBLIC_URL + '/images/logo_menu_app.png'} alt="Logo" height = "70%" width = "50%" className={classes.toolbarLogo}  />
                </Typography>
                <Divider component="li" style={{backgroundColor: '#FFFFFF'}}/>
                <MenuItems  items = { Items.filter(item => item.web) } sendData = { sendData } menuselectedsimple = { menuselectedsimple } submenuCollapseSelected = { submenuCollapseSelected } menuselectedcollapse = { menuselectedcollapse } menuCollapseSelected = { menuCollapseSelected }/>
            </Drawer>
            </Hidden>
        </nav>
    );
};

MenuDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    closeDrawer: PropTypes.func.isRequired,
};

export default MenuDrawer;

/*
    <div>
            <SwipeableDrawer
                anchor={anchor}
                open={open}
                onClose={closeDrawer}
                onOpen={closeDrawer}
            >
                <MenuHeader />
                <MenuItems anchor= {anchor}  items = { Items } sendData = { sendData } />
            </SwipeableDrawer>
        </div>

*/
